import React from "react";
import WeddingGallery from "pub/pages/wedding/WeddingGallery";
export default [
  {
    path: "/wedding/gallery",
    element: <WeddingGallery />,
  },
];
